export const startLoader = () => {
    function id(v) { return document.getElementById(v); }
    function loadbar() {
        var ovrl = id("overlay"),
            prog = id("progress"),
            stat = id("progstat"),
            welcome = id("welcome"),
            img = document.images,
            c = 0,
            tot = img.length;
        if (tot == 0) return doneLoading();

        function imgLoaded() {
            c += 1;
            var perc = ((100 / tot * c) << 0) + "%";
            prog.style.width = perc;
            stat.innerHTML = "Wird geladen " + perc;
            if (c === tot) return doneLoading();
        }
        function doneLoading() {
            setTimeout(function () {
                prog.style.opacity = 0;
                stat.style.opacity = 0;
                welcome.style.opacity = 1;
                // hide overlay
                setTimeout(() => {
                    ovrl.style.opacity = 0;
                    setTimeout(() => {
                        ovrl.style.display = "none";
                    }, 1200)
                }, 2500)
            }, 1000);
        }
        for (var i = 0; i < tot; i++) {
            var tImg = new Image();
            tImg.onload = imgLoaded;
            tImg.onerror = imgLoaded;
            tImg.src = img[i].src;
        }
    }

    loadbar();
};